import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import Home from './pages/home/Home';
import Dashboard from "./pages/client/dashboard/Dashboard";
import Console from "./pages/client/console/Console";
import Map from "./pages/client/map/Map";
import AuditLog from "./pages/client/audit_log/AuditLog";
import Players from "./pages/client/players/Players";
import Bans from "./pages/client/bans/Bans";
import Client from "./pages/client/Client";
import Whitelist from "./pages/client/whitelist/Whitelist";
import Moderators from "./pages/client/moderators/Moderators";
import Permissions from "./pages/client/permissions/Permissions";
import Login from "./pages/home/pages/Login";
import Index from "./pages/home/pages/Index";
import NotFound from "./pages/NotFound";
import Settings from "./pages/client/settings/Settings";
import Chat from "./pages/client/chat/Chat";
import Stats from "./pages/client/stats/Stats";
import Account from "./pages/home/account/Account";
import Pricing from "./pages/home/pages/Pricing";
import AdminDashboard from "./pages/admin/AdminDashboard";
import LegalPage from "./pages/home/legal/LegalPage";

// https://reactrouter.com/en/main/start/concepts#matching
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home />} >
                <Route index element={<Index />} />
                <Route path="login" element={<Login />} />
                <Route path="account" element={<Account />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="imprint" element={<LegalPage slug="imprint" />} />
                <Route path="privacy" element={<LegalPage slug="privacy" />} />
                <Route path="terms" element={<LegalPage slug="terms" />} />
            </Route>
            <Route path="/client" element={<Client />} >
                <Route index element={<span></span>} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="console" element={<Console />} />
                <Route path="chat" element={<Chat />} />
                <Route path="map" element={<Map />} />
                <Route path="log" element={<AuditLog />} />
                <Route path="players" element={<Players />} />
                <Route path="bans" element={<Bans />} />
                <Route path="stats" element={<Stats />} />
                <Route path="whitelist" element={<Whitelist />} />
                <Route path="permissions" element={<Permissions />} />
                <Route path="moderators" element={<Moderators />} />
                <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="/admindashboard" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// Enhanced Service Worker Registration
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then((registration) => {
                console.log('SW registered: ', registration);

                // Check for updates every 5min
                setInterval(() => {
                    registration.update();
                }, 300000);

                // Also check for updates when the app regains focus
                document.addEventListener('visibilitychange', () => {
                    if (!document.hidden) {
                        registration.update();
                    }
                });
            })
            .catch((registrationError) => {
                console.log('SW registration failed: ', registrationError);
            });
    });
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
